import { AbstractControl, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { ValidationType } from "./validation.model";

export interface ConstrainedFieldValParams {
  min?: number,
  max?: number,
  required?: boolean,
}

export interface ConstrainedField {
  key: string;
  controlType: ValidationType;
  control: AbstractControl;
  editable: boolean;
  hidden: boolean;
  tooltip: string | null;
  validators: ValidatorFn[];
  extraData: any;
}

export function createConstrainedField(options: {
  key: string,
  controlType: ValidationType,
  control: AbstractControl,
  editable?: boolean,
  initiallyDisabled?: boolean,
  hidden?: boolean,
  tooltip?: string,
  validators?: ValidatorFn[],
  validationParams?: ConstrainedFieldValParams,
  extraData?: any,
}): ConstrainedField {
  const validators = options.validators ?? (options.validationParams ? createValidators(options.controlType, options.validationParams) : []);

  const constrainedField: ConstrainedField = {
    key: options.key,
    controlType: options.controlType,
    control: options.control,
    editable: options.editable ?? false,
    hidden: options.hidden ?? false,
    tooltip: options.tooltip ?? null,
    validators: validators,
    extraData: options.extraData,
  };

  constrainedField.control.setValidators(validators);

  if (options.initiallyDisabled || !options.editable) {
    constrainedField.control.disable({ emitEvent: false });
  }

  return constrainedField;
}

function createValidators(controlType: ValidationType, validationParams: ConstrainedFieldValParams): ValidatorFn[] {
  let validators: ValidatorFn[] = [];

  if (validationParams.required)
    validators.push(Validators.required);

  if (controlType === "numeric") {
    if (validationParams.min || (validationParams.min == 0))
      validators.push(Validators.min(validationParams.min));
    if (validationParams.max)
      validators.push(Validators.max(validationParams.max));
  }
  else {
    if (validationParams.min || (validationParams.min == 0))
      validators.push(Validators.minLength(validationParams.min));
    if (validationParams.max)
      validators.push(Validators.maxLength(validationParams.max));
  }

  return validators;
}

export function toFormGroup(fields: ConstrainedField[]): FormGroup {
  const group: Record<string, AbstractControl> = {};

  for (const field of fields) {
    group[field.key] = field.control;
  }

  return new FormGroup(group);
}
